import {useEffect} from 'react';

/**
 * PIXTA 画像要素について、クライアント側で行う必要のある処理を行う effect
 * - 右クリックのコンテクストメニューを無効化
 * - ドラッグを無効化する CSS のためのクラスを付与
 */
export const useDecoratePixtaEffect = () => {
  useEffect(() => {
    const pixtaImages = [...document.querySelectorAll('img')].filter((img) =>
      img.src.includes('pixta_'),
    );

    const preventEvent = (event: Event) => {
      event.preventDefault();
    };

    for (const img of pixtaImages) {
      // 右クリックのコンテクストメニュー、ドラッグ開始、コピーのイベントをキャンセル
      img.addEventListener('contextmenu', preventEvent);
      img.addEventListener('dragstart', preventEvent);
      img.addEventListener('copy', preventEvent);
      // ドラッグを無効化する CSS のためのクラスを付与
      img.classList.add('img-nodrag');

      // キャプション要素を追加
      if (img.nextElementSibling === null) {
        img.parentElement?.append(createCaptionElement(img));
      }
      // 既に画像キャプション要素がある時、pixta キャプションと元のキャプション両方を表示する
      else {
        img.parentElement?.insertBefore(
          createCaptionElement(img),
          img.nextElementSibling,
        );
      }
    }

    return () => {
      for (const img of pixtaImages) {
        img.removeEventListener('contextmenu', preventEvent);
        img.removeEventListener('dragstart', preventEvent);
        img.removeEventListener('copy', preventEvent);
      }
    };
  }, []);
};

const createCaptionElement = (img: HTMLImageElement) => {
  // img.src の値から pixta 画像 ID を取得
  const pixtaId = /pixta_(\d+)/.exec(img.src)?.[1];
  if (pixtaId === undefined) {
    throw new Error('pixta id is not found from src value');
  }

  const element = document.createElement('div');
  const linkElement = document.createElement('a');

  element.append(linkElement);
  element.classList.add('image-caption', 'pixta-copyright');
  linkElement.target = '_blank';
  linkElement.href = `https://pixta.jp/photo/${pixtaId}`;
  linkElement.textContent = 'photo by pixta.jp';

  return element;
};
